document.addEventListener('DOMContentLoaded', () => {
  const revealItems = document.querySelectorAll('.kyuub-reveal');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
  }, { threshold: 0.12 });
  revealItems.forEach((item) => observer.observe(item));

  const heroLayers = document.querySelectorAll('[data-hero-layer]');
  let heroIndex = 0;
  if (heroLayers.length > 1) {
    heroLayers[0].classList.add('is-active');
    setInterval(() => {
      heroLayers[heroIndex].classList.remove('is-active');
      heroIndex = (heroIndex + 1) % heroLayers.length;
      heroLayers[heroIndex].classList.add('is-active');
    }, 4300);
  }

  document.querySelectorAll('[data-kyuub-ba]').forEach((slider) => {
    const range = slider.querySelector('[data-kyuub-range]');
    const after = slider.querySelector('[data-kyuub-after]');
    const divider = slider.querySelector('[data-kyuub-divider]');
    const update = () => {
      const value = range.value;
      after.style.clipPath = `inset(0 ${100 - value}% 0 0)`;
      divider.style.left = `${value}%`;
    };
    range.addEventListener('input', update);
    update();
  });
});
